import { useLocation } from "react-router-dom";
import { parseQueryString } from "@ugg/shared/utils/url-query-params";
import { SvgNotificationAlert } from "@ugitgud/legos/ui/icon/SVG/NotificationAlert";
import { useDetectApp, openWowAccountSettings } from "lib/monoapp";

const IcyVeinsLoginNotice = () => {
  const location = useLocation();
  const isApp = useDetectApp();
  const { game } = parseQueryString(location.search.substring(1));

  if (!isApp || game === "wow") {
    return null;
  }

  return (
    <div
      className="w-full max-w-[300px] h-fit rounded-[4px] p-[24px] text-[14px] text-lavender-50 font-inter"
      style={{
        background: "rgba(7, 7, 32, 0.4)",
        backdropFilter: "blur(15px)",
        WebkitBackdropFilter: "blur(15px)",
      }}
    >
      <div className="mb-[8px] flex items-center gap-[8px] text-white text-[16px] font-bold">
        <SvgNotificationAlert className="w-[18px] h-[18px] shrink-0 text-accent-orange-500" />
        Looking for Icy Veins?
      </div>
      <p className="mb-[12px] leading-normal">
        Your Icy Veins subscription is separate from your U.GG account and won't log you in here. Sign in from the WoW app
        instead, under Settings → Account. Icy Veins Premium still keeps the entire app ad-free.
      </p>
      <button type="button" onClick={openWowAccountSettings} className="underline text-accent-blue-400 font-bold">
        Open WoW settings
      </button>
    </div>
  );
};

export default IcyVeinsLoginNotice;
